"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initHeightEqualizer = initHeightEqualizer;
const utils_1 = require("./utils");
function initHeightEqualizer() {
    const machineHs = (0, utils_1.qsa)('.machine__h');
    const recentProjectsItemHeaders = (0, utils_1.qsa)('.recent-projects__item-h');
    const heightEqualiseArrays = [recentProjectsItemHeaders, machineHs];
    if (!heightEqualiseArrays.length)
        return;
    const brakePoint = matchMedia('(min-width: 620px)');
    const setMinHeight = (arr) => {
        if (!arr.length)
            return;
        // Reset heights
        arr.forEach((el) => (el.style.minHeight = ''));
        let max = 0;
        // Find max height
        arr.forEach((el) => {
            const h = el.scrollHeight;
            if (h > max)
                max = h;
        });
        // Set min height
        arr.forEach((el) => {
            el.style.minHeight = brakePoint.matches ? `${max}px` : 'unset';
        });
    };
    // Initial setup
    heightEqualiseArrays.forEach((arr) => setMinHeight(arr));
    // Re-calculate on orientation change
    matchMedia('(orientation: portrait)').addEventListener('change', () => {
        setTimeout(() => {
            heightEqualiseArrays.forEach((arr) => setMinHeight(arr));
        }, 200);
    });
}
